import './bootstrap';
import 'bootstrap/dist/js/bootstrap.bundle';

// validate
import './validate';

import Alpine from 'alpinejs';
window.Alpine = Alpine;
Alpine.start();

$(document).ready(function(){
    $('#overlay').fadeOut();
});

window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', event => {
    const newColorScheme = event.matches ? "dark" : "light";
    if (newColorScheme == 'dark') {
        $('#loginLogoLight').addClass('d-none');
        $('#loginLogoDark').removeClass('d-none');
    } else {
        $('#loginLogoLight').removeClass('d-none');
        $('#loginLogoDark').addClass('d-none');
    }
});

if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    $('#loginLogoLight').addClass('d-none');
} else {
    $('#loginLogoDark').addClass('d-none');
}

// setup ajax
$.ajaxSetup({
    headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')}
});